import { render, staticRenderFns } from "./ReceiptRecord.vue?vue&type=template&id=2dc857d0&scoped=true"
import script from "./ReceiptRecord.vue?vue&type=script&lang=js"
export * from "./ReceiptRecord.vue?vue&type=script&lang=js"
import style0 from "./ReceiptRecord.vue?vue&type=style&index=0&id=2dc857d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc857d0",
  null
  
)

export default component.exports